/*
 * @Author: lc
 * @Date: 2022-12-07 11:32:00
 * @LastEditors: lc
 * @LastEditTime: 2023-04-07 11:06:13
 * @Description: 
 */
/**
  * 后台统计接口
  */
import axios from '.././http' // 导入http中创建的axios实例
import qs from 'qs' // 根据需求是否导入qs模块，把请求字段直接映射过来

const api = '/c-api/'

const maincount = {
    // 查询
    index (params) {
        return axios.get(api + 'maincount/index', { params: params })
    },
    // 会员统计
    userscount (params) {
        return axios.get(api + 'maincount/userscount', { params: params })
    },
    // 访客统计
    visitornumcount (params) {
        return axios.get(api + 'maincount/visitornumcount', { params: params })
    },
    // 销售金额统计
    salemoneycount (params) {
        return axios.get(api + 'maincount/salemoneycount', { params: params })
    },
    // 销售数量统计
    salenumcount (params) {
        return axios.get(api + 'maincount/salenumcount', { params: params })
    },
}

// 导出接口
export default maincount
